import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';
// tslint:disable-next-line
register('stage-slider', () => import(/* webpackMode: "lazy" */'./stage-slider'));
